import { render, staticRenderFns } from "./ApprovalAlert.vue?vue&type=template&id=72540525&scoped=true"
import script from "./ApprovalAlert.vue?vue&type=script&lang=ts"
export * from "./ApprovalAlert.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalAlert.vue?vue&type=style&index=0&id=72540525&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72540525",
  null
  
)

export default component.exports